<template>
  <div class="do-dont-wrapper">
    <h3 @click="handleShowContent" class="clickable-header">{{guidelineTitle}}</h3>
    <div class="do-dont-wrapper" v-show="showContent">
      <div class="intro-paragraph" v-html="intro">

      </div>

      <div class="box-wrapper-do-dont">
        <div class="box do">
          <h2>{{DosTitle}}</h2>
          <div v-html="dos"></div>
        </div>
        <div class="box dont">
          <h2>{{DontsTitle}}</h2>
          <div v-html="donts"></div>
        </div>
      </div>
      <div class="disclaimers" v-html=disclaimers />

    </div>
    <div class="faq-wrapper">
      <h3 @click="handleShowFAQs" class="clickable-header">{{faqsTitle}}</h3>
      <div class="faqs-wrapper" v-show="showFAQs" v-for="(faq, index) in faqs" :key="index">
        <button
          class="accordion"
          :class="{ active: faqIsactive }"
          @click="handleAccordionClick"
        >
          {{ faq.faq_title }}
        </button>
        <div class="panel" v-html="faq.faq_answer">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Body',
    props: {
        strings: Array,
        faqs: {
            type: Array,
            default: () => []
        },
        dos: {
            type: String,
            default: ''
        },
        donts: {
            type: String,
            default: ''
        },
        intro: String,
        disclaimers: String,
        guidelineTitle: String,
        faqsTitle: String,
        DosTitle: String,
        DontsTitle: String
    },
    data() {
        return {
            faqIsactive: false,
            showContent: false,
            showFAQs: false
        };
    },
    methods: {
        handleAccordionClick(event) {
            const accordion = event.target;
            accordion.classList.toggle('active');
            const panel = accordion.nextElementSibling;
            if (panel.style.display === 'block') {
                panel.style.display = 'none';
            } else {
                panel.style.display = 'block';
            }
        },
        handleShowContent(event) {
            const activeHeader = event.target;
            activeHeader.classList.toggle('active');
            this.showContent = !this.showContent;
        },
        handleShowFAQs(event) {
            const activeHeader = event.target;
            activeHeader.classList.toggle('active');
            this.showFAQs = !this.showFAQs;
        }
    }
};
</script>

<style lang="scss">
.do-dont-wrapper {
  font-family: "inter", sans-serif;

  color: #252525;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  max-width: 1440px;
  margin: 0 auto 60px;
  box-sizing: border-box;

  h2 {
    font-family: "Lora", sans-serif;
    font-size: 36px;
    font-style: normal;
    font-weight: 400;
    line-height: 42px;
    margin: 20px 0;
  }

  .intro-paragraph {
    max-width: 1440px;
    margin: 0 auto 24px auto;
    padding: 0 20px 20px;
    font-family: "inter", sans-serif;

    p {
      font-family: "inter", sans-serif;
      color: #252525;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      margin: 16px 0;
    }
  }

  .box-wrapper-do-dont {
    display: grid;
    align-items: stretch;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
  }
  .clickable-header {
    cursor: pointer;
    position: relative;
    font-family: "Lora", sans-serif;

    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 38px;
    margin: 0;
    padding: 0 0 20px;
    &::after {
      font-family: "Material Icons";
      content: "\e5cf";
      color: #252525;
      font-weight: bold;
      font-size: 32px;
      position: absolute;
      right: 0;

      margin-left: 5px;
      margin-bottom: 20px;
    }
    &.active::after {
      font-family: "Material Icons";
      content: "\e5ce";
    }
  }
  .box {
    grid-column-end: span 1;
    border: 2px solid #5f5f5f;
    border-radius: 25px;
    padding: 20px;
    position: relative;
    font-family: "inter", sans-serif;

    h2 {
      font-family: "Lora", sans-serif;
      font-size: 36px;
      font-style: normal;
      font-weight: 400;
      line-height: 42px;
    }

    &.do::before {
      font-family: "Material Icons";
      content: "\e86c";
      color: #6bc56a;
      font-size: 20px;
      margin-right: 10px;
      position: absolute;
      top: -10px;
      left: -10px;
      background-color: white;
      font-size: 35px;
      border-radius: 50%;
    }

    &.dont::before {
      font-family: "Material Icons";
      content: "\e5c9";
      color: #c81d1d;
      font-size: 20px;
      margin-right: 10px;
      position: absolute;
      top: -10px;
      left: -10px;
      background-color: white;
      font-size: 35px;
      border-radius: 50%;
    }

    ul {
      font-family: "inter", sans-serif;
      font-size: 16px;
      list-style-type: disc;
      font-weight: 400;
      line-height: 22px;
      margin-bottom: 20px;
      padding-left: 20px;

      li {
        font-family: "inter", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        margin-bottom: 10px;
        &.do-list-item-4, &.do-list-item-5, &.do-list-item-6, &.do-list-item-7, &.do-list-item-8 {
          margin-left: 20px;
        }
      }
    }
  }

  .disclaimers {
    max-width: 1440px;
    margin: 0 auto;
    padding: 20px;
    font-family: "inter", sans-serif;

    p {
      font-family: "inter", sans-serif;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
      /* 133.333% */
      letter-spacing: 0.12px;
    }
  }

  .faq-wrapper {
    max-width: 1440px;
    margin: 0 auto;
    padding: 20px 0px;
    font-family: "inter", sans-serif;
    border-top: 1px solid #b2b2b2;
    .accordion {
      display: flex;
      padding: 9px 45px 9px 0;
      align-items: center;
      gap: 8px;
      transition: 0.4s;
      width: 100%;
      background-color: white;
      position: relative;
      border: none;
      border-bottom: 1px solid #b2b2b2;
      font-family: "Inter", sans-serif;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      text-align: left;
      color: #252525;

      &:hover {
        cursor: pointer;
      }

      &::after {
        font-family: "Material Icons";
        content: "\e5cf";
        color: #252525;
        font-weight: bold;
        font-size: 24px;
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        margin-left: 5px;
        margin-bottom: 20px;
      }

      &.active::after {
        font-family: "Material Icons";
        content: "\e5ce";
      }
    }

    .panel {
      padding: 0 20px 0px;
      display: none;
      background-color: #f1f1f1;
      border: 1px solid #b2b2b2;
      border-top: 0;
      overflow: hidden;
      font-size: 16px;
      line-height: 22px;
      width: 100%;
      margin-bottom: 20px;
      box-sizing: border-box;

      p {
        font-family: "inter", sans-serif !important;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        margin: 16px 0;
      }

      ul {
        font-family: "inter", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        margin: 16px 0 0 16px;
        padding-left: 20px;
        list-style-type: disc;

        li {
          font-family: "inter", sans-serif !important;
          font-size: 16px !important;
          font-style: normal;
          font-weight: 400 !important;
          line-height: 22px !important;
          margin-bottom: 10px !important;
        }
      }
    }
  }
}
</style>
